import { render } from "./PostReviewerAttributeItem.vue?vue&type=template&id=7ef6dca0&ts=true"
import script from "./PostReviewerAttributeItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostReviewerAttributeItem.vue?vue&type=script&lang=ts&setup=true"

import "./PostReviewerAttributeItem.vue?vue&type=style&index=0&id=7ef6dca0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/PostReviewerAttributeItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ef6dca0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ef6dca0', __exports__)) {
    api.reload('7ef6dca0', __exports__)
  }
  
  module.hot.accept("./PostReviewerAttributeItem.vue?vue&type=template&id=7ef6dca0&ts=true", () => {
    api.rerender('7ef6dca0', render)
  })

}


export default __exports__